import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { userHasRole, intermediaryAccess } from 'helpers/helpers';
import { ROLES_ASEGURADO, ROLES_CORREDOR } from 'CONST';
import { getData } from '../../../../redux-store/actions';
import { API, BASE_URL } from 'CONST';
import { CP_GET_LIST, CP_SET_CORREDOR_POLIZAS } from '../../../../redux-store/constants/action-types';
import { get } from '../../../../helpers/requests';

const SolicitudProrrogaRedirectContainer = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login.user);
  const client = useSelector((state) => state.login.client);
  const creditPolicies = useSelector((state) => state.credito?.list?.creditPolicies);
  const isLoading = useSelector((state) => state.credito.list?.loading) || false;
  const corredorPolizas = useSelector((state) => state.credito.list.corredorPolizas);
  const [dataInitialized, setDataInitialized] = useState(false);
  const [corredorPolizasReady, setCorredorPolizasReady] = useState(false);
  const isAsegurado = userHasRole(user, ROLES_ASEGURADO) && !userHasRole(user, ROLES_CORREDOR);
  const isCorredor = intermediaryAccess(user);

  useEffect(() => {
    if (!isCorredor) return;

    if (corredorPolizas.length > 0) {
      setCorredorPolizasReady(true);
      return;
    }

    const load = async () => {
      try {
        const url = `${BASE_URL}${API.creditosIntermediarios}/polizas/?corredor_id=${user.organization}`;
        const polizas = await get(url);
        const options = polizas.map((poliza) => ({
          label: `${poliza.nemotecnico} - ${poliza.asegurado_nombre || 'Sin cliente'}`,
          value: {
            id: poliza.poliza_id,
            nemotecnico: poliza.nemotecnico,
            asegurado_nombre: poliza.asegurado_nombre,
          },
        }));
        dispatch({ type: CP_SET_CORREDOR_POLIZAS, payload: options });
      } catch (error) {
        console.error('Error preloading polizas:', error);
      } finally {
        setCorredorPolizasReady(true);
      }
    };

    load();
  }, [isCorredor]);

  useEffect(() => {
    if (!user || isCorredor) return;
    // checkeo de data para evitar montar y desmontar el CP_GET_LIST a cada rato
    const hasValidData = creditPolicies?.data && creditPolicies.data.length > 0;
    const shouldLoadData = !dataInitialized && !hasValidData && !isLoading;

    if (shouldLoadData) {
      let filterParams = '';
      
      if (user.is_orsan && client) {
        filterParams = `client_id=${client.id}`;
      }
      
      if (intermediaryAccess(user) && client) {
        const clientParam = client ? `client_id=${client.id}` : '';
        const intermediaryParam = `intermediario_id=${user.organization}`;
        filterParams = clientParam ? `${clientParam}&${intermediaryParam}` : intermediaryParam;
      }
      
      const url = filterParams 
        ? `${BASE_URL}${API.creditos}?${filterParams}`
        : `${BASE_URL}${API.creditos}`;
      
      dispatch(getData({
        url,
        type: CP_GET_LIST,
      }));
    }

    if (hasValidData && !dataInitialized) {
      setDataInitialized(true);
    }
  }, [dispatch, user, client, creditPolicies, isLoading, dataInitialized, isCorredor]);

  useEffect(() => {
    if (isCorredor) return;
    const hasValidData = creditPolicies?.data && creditPolicies.data.length > 0;
    if (!isLoading && hasValidData && !dataInitialized) {
      setDataInitialized(true);
    }
  }, [isLoading, creditPolicies, dataInitialized, isCorredor]);

  // All hooks must be called before any conditional returns
  
  // If user is Corredor, redirect directly to the page without policyId
  // They will select client and policy there
  if (isCorredor) {
    if (!corredorPolizasReady) return <div>Cargando pólizas...</div>;
    return <Redirect to="/prorroga/solicitud-prorroga" />;
  }

  if (!isAsegurado && !isCorredor) {
    return <Redirect to="/" />;
  }

  if (!dataInitialized || isLoading) {
    return <div>Cargando pólizas...</div>;
  }

  // si no hay polizas
  if (!creditPolicies?.data || creditPolicies.data.length === 0) {
    return <Redirect to="/asegurado/polizas-credito" />;
  }

  // Si hay 1 poliza
  if (creditPolicies.data.length === 1) {
    return <Redirect to={`/prorroga/solicitud-prorroga/${creditPolicies.data[0].id}`} />;
  }

  // Si hay muchas polizas
  return <Redirect to="/asegurado/polizas-credito" />;
};

export default SolicitudProrrogaRedirectContainer;
